<template>
  <div class="dashboard-container"></div>
</template>

<script>
export default {
  name: 'dashboard',
}
</script>
